"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var store_1 = require("../../store");
var FormatText_1 = __importDefault(require("../FormatText"));
var Icon_1 = __importDefault(require("../Icon"));
var MenuItemContent = function (_a) {
    var label = _a.label, icon = _a.icon, topArea = _a.topArea;
    var username = store_1.useStore(function (store) { return store.permission; }).username;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        icon && react_1.default.createElement(Icon_1.default, { name: icon }),
        react_1.default.createElement("span", null,
            react_1.default.createElement(FormatText_1.default, { id: topArea && username ? username : label }))));
};
exports.default = MenuItemContent;
